import { PaymentTypeModelType } from '@teinor/erp/types/company/config/paymentType'

interface PaymentTypesAction {
    type: 'CHANGE_PAYMENTTYPES'
    payload: PaymentTypeModelType[]
}

type PaymentTypesResult = { activeTpv: PaymentTypeModelType[], all: DictionaryPaymentType, allArr: PaymentTypeModelType[] }
type DictionaryPaymentType = { [id: number]: PaymentTypeModelType }
export type PaymentTypesPayload = PaymentTypesResult | null

export default function paymentTypes(state: PaymentTypesPayload = null, action: PaymentTypesAction): PaymentTypesPayload {
    switch (action.type) {
        case 'CHANGE_PAYMENTTYPES':
            let paymentTypes: PaymentTypesPayload = {
                activeTpv: [],
                allArr: action.payload,
                all: {}
            }
            for (const element of action.payload) {
                if (element.activeTpv && element.active) {
                    paymentTypes.activeTpv.push(element)
                }
                paymentTypes.all[element.id] = element
            }
            return state = paymentTypes
        default:
            return state
    }
}